import {
    Text,
    Container,
    ActionIcon,
    Group,
    rem,
    Image,
    Anchor,
    Flex,
} from "@mantine/core";
import {
    IconBrandInstagram,
    IconBrandLinkedin,
    IconBrandX,
    IconBrandFacebook,
    IconMail,
} from "@tabler/icons-react";
import logo from "./logo-color.png";
import classes from "./Footer.module.css";

const data = [
    {
        title: "About",
        links: [
            { label: "Home", link: "https://pinesnutrition.org/" },
            {
                label: "Our Board",
                link: "https://pinesnutrition.org/our-board/",
            },
            {
                label: "Member Profiles",
                link: "https://pinesnutrition.org/member-profiles/",
            },
            {
                label: "Global Connection",
                link: "https://pinesnutrition.org/global-connection/",
            },
            {
                label: "Join Pines",
                link: " https://pinesnutrition.org/join-pines/",
            },
        ],
    },
    {
        title: "Important Links",
        links: [
            {
                label: "Resources",
                link: "https://pinesnutrition.org/articles/",
            },
            {
                label: "Terms & Conditions",
                link: "https://pinesnutrition.org/term-and-conditions/",
            },
            {
                label: "Refund Policy",
                link: "https://pinesnutrition.org/privacy-payment-refund-policy/",
            },
            {
                label: "Membership Categories",
                link: "https://pinesnutrition.org/low-income-membership-categories/",
            },
            {
                label: "Annual Report",
                link: "https://pinesnutrition.org/annual-report/",
            },
        ],
    },
    {
        title: "Community",
        links: [
            {
                label: "Careers",
                link: "https://pinesnutrition.org/career-in-sportsa/",
            },
            { label: "Education", link: "https://pinesnutrition.org/esn/" },
            {
                label: "Scholarships & Awards",
                link: "https://pinesnutrition.org/scholarships-and-awards/",
            },
            //modern browsers blocks the mailto, so commented out
            // {
            //     label: "Join PINES Listserv",
            //     link: "mailto:PINESNutrition+subscribe@groups.io",
            // },
        ],
    },
];

const socialLinks = [
    // {
    //     icon: (
    //         <IconMail
    //             style={{ width: rem(18), height: rem(18) }}
    //             stroke={1.5}
    //         />
    //     ),
    //     link: "mailto:PINESNutrition+subscribe@groups.io",
    // },
    {
        icon: (
            <IconBrandX
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
            />
        ),
        link: "https://x.com/PINESorg",
    },
    {
        icon: (
            <IconBrandLinkedin
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
            />
        ),
        link: "https://www.linkedin.com/company/pines-org/",
    },
    {
        icon: (
            <IconBrandInstagram
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
            />
        ),
        link: "https://www.instagram.com/pinesorg/",
    },
    {
        icon: (
            <IconBrandFacebook
                style={{ width: rem(18), height: rem(18) }}
                stroke={1.5}
            />
        ),
        link: "https://www.facebook.com/PINESNUTRITION",
    },
];

const Footer = () => {
    const groups = data.map((group) => {
        const links = group.links.map((link, index) => (
            <Anchor
                key={index}
                className={classes.link}
                href={link.link}
                target="_self"
                c="black"
                style={{ textDecoration: "none" }}
            >
                {link.label}
            </Anchor>
        ));

        return (
            <div className={classes.wrapper} key={group.title}>
                <Text className={classes.title}>{group.title}</Text>
                {links}
            </div>
        );
    });

    return (
        <footer className={classes.footer}>
            <Container className={classes.inner}>
                <div className={classes.logo}>
                    <Image h={70} w={"auto"} src={logo} alt="pines"></Image>
                    <Text size="xs" className={classes.description}>
                        PINES is a leading global organization of qualified
                        nutrition and exercise professionals who strive for
                        excellence in sports nutrition in order to achieve
                        optimal support for performance, health and injury
                        prevention for active and athletic individuals
                        worldwide.
                    </Text>
                </div>
                <div className={classes.groups}>{groups}</div>
            </Container>

            {/* email here */}
            <Flex
                justify="flex-end"
                mr={{ base: 20, sm: 50, md: 100, lg: 200 }}
                mt={10}
                align="center"
            >
                <IconMail
                    style={{
                        width: rem(18),
                        height: rem(18),
                        display: "flex",
                        alignSelf: "center",
                    }}
                    stroke={1.5}
                />
                <Text
                    component="span"
                    ml={8}
                    style={{ display: "flex", alignItems: "center" }}
                >
                    info@pinesnutrition.org
                </Text>
            </Flex>

            <Container className={classes.afterFooter}>
                <Text size="sm">© 2024 PINES. All rights reserved.</Text>

                <Group
                    gap={0}
                    className={classes.social}
                    justify="flex-end"
                    wrap="nowrap"
                >
                    {socialLinks.map((item) => (
                        <ActionIcon key={item.link} size="lg" variant="subtle">
                            <Anchor
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {item.icon}
                            </Anchor>
                        </ActionIcon>
                    ))}
                </Group>
            </Container>
        </footer>
    );
};

export default Footer;
